import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

interface GetCategoryResultListParams {
	organization_id: string;
	company_id: string;
	review_id: string;
	report_id: string;
	activity_id: string;
}

const Service = Resolution886ReportService.getInstance();

function isEnabled(params: GetCategoryResultListParams): boolean {
	return (
		!!params.organization_id &&
		!!params.company_id &&
		!!params.review_id &&
		!!params.report_id &&
		!!params.activity_id
	);
}

export function useGetCategoryResultList(params: GetCategoryResultListParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_RESOLUTION_886_CATEGORY_RESULT_LIST, params],
		queryFn: async () => Service.getCategoryResultList(params),
		enabled: isEnabled(params)
	});
}
